module.exports = __webpack_public_path__ + "static/img/jia1.1f71ac7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/基因调控/甲基化检测/jia1.jpg
// module id = q+Qx
// module chunks = 16